import { logError } from '@zg-rentals/log-error';

import UserActions from '../../flux/actions/UserActions';
import filterUtils from '../../utils/filterUtils';
import { decodeFullAddressFromUrl } from '../../utils/urlUtils';
import { loadFilterFromUrl } from '../../flux/actions/FilterActions';
import { getAddressAndComparables } from '../../flux/actions/AddressActions';

const serverRouteWillMount = ({ store }: { store: any }) => {
  const { dispatch } = store;
  // Get user info
  dispatch(UserActions.getUser());
  const state = store.getState();
  const pathname = state.router.location.pathname;
  const queryObject = state.router.location.query;
  const queryString = state.router.location.search;
  const filterParams = filterUtils.queryStringToGraphQLParams(queryString);
  const addressDataObject = decodeFullAddressFromUrl({
    pathname,
    unit: queryObject.unit,
  });
  const params = { ...addressDataObject, ...filterParams };

  // @ts-ignore
  dispatch(loadFilterFromUrl(queryObject)).catch((err) => {
    logError({
      error: err,
      errorType: 'Filter',
      context: {
        details: 'Results page: Error loading filter from url (SSR)',
        root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
      },
    });
  });

  // @ts-ignore
  return dispatch(getAddressAndComparables(params)).catch((err) => {
    logError({
      error: err,
      errorType: 'Address',
      context: {
        details: 'Results page: Error loading address/comps (SSR)',
        root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
        pathAttempted: pathname,
        queryAttempted: queryString,
      },
    });
  });
};
export default serverRouteWillMount;
